<template>
<svg :width="width" :height="height" viewBox="0 0 16 16" :fill="color" xmlns="http://www.w3.org/2000/svg">
<path xmlns="http://www.w3.org/2000/svg" d="M8 1.93936L9.88718 5.0752C10.1664 5.53922 10.6219 5.87016 11.1495 5.99236L14.7151 6.81814L12.3159 9.58198C11.9609 9.99096 11.7869 10.5264 11.8337 11.066L12.1501 14.7122L8.78018 13.2845C8.28152 13.0732 7.71849 13.0732 7.21982 13.2845L3.84986 14.7122L4.1663 11.066C4.21313 10.5264 4.03914 9.99096 3.68412 9.58198L1.28493 6.81814L4.85046 5.99236C5.37807 5.87016 5.83357 5.53922 6.11282 5.0752L8 1.93936Z" :fill="color" :stroke="color" stroke-width="2"/>
</svg>

</template>

<script>

export default {
    props: {
        width: { type: [Number, String], default: 16 },
        height: { type: [Number, String], default: 16 },
        color: { type: String, default: '#006EFF' }
    }
}
</script>
